import * as React from 'react';
import Svg, {G, Path, Defs, ClipPath} from 'react-native-svg';

interface IProps {
  width?: number;
  height?: number;
  color?: string;
}

function RewardsAddToCart(props: IProps) {
  return (
    <Svg
      width={props.width ?? 35}
      height={props.height ?? 34}
      viewBox="0 0 35 34"
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_25787_3954)">
        <Path
          d="M4.625 5C4.002 5 3.5 5.502 3.5 6.125S4.002 7.25 4.625 7.25h2.133a.38.38 0 01.37.305l2.419 12.703A3.374 3.374 0 0012.86 23h13.514c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125H12.861a1.13 1.13 0 01-1.106-.914l-.253-1.336h13.523a3.367 3.367 0 003.258-2.498l1.922-7.14a1.874 1.874 0 00-1.81-2.362H9.13A2.62 2.62 0 006.758 5H4.625zm5.02 3.75h18.263l-1.796 6.666a1.124 1.124 0 01-1.087.834h-13.95l-1.43-7.5zM11.75 29a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm15.75-2.25a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0z"
          fill={props.color ?? '#006DFF'}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_25787_3954">
          <Path fill="#fff" transform="translate(3.5 5)" d="M0 0H27V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default RewardsAddToCart;
